export default __webpack_public_path__ + "static/media/footer_logo.28f6d92e.svg";